var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "width": "86%",
      "height": "auto",
      "is-loc": "center"
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "pop-main popUsdInvite"
  }, [_c('div', {
    staticClass: "popUsdInvite-title"
  }, [_c('div', {
    staticClass: "popUsdInvite__title"
  }, [_vm._v("Invite to earn")])]), _c('div', {
    staticClass: "popUsdInvite-total"
  }, [_c('span', {
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm._v("My reward "), _c('i', [_c('svg-icon', {
    attrs: {
      "spin": _vm.isRefresh,
      "name": "icon-refresh"
    }
  })], 1)]), _c('em', [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/TAP-small.png`),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm._f("fmt_pre")(_vm.myReward)))])]), _c('div', {
    staticClass: "popUsdInvite-friend",
    class: !_vm.activityList.length && 'bor'
  }, [_c('div', {
    staticClass: "popUsdInvite-friend__info"
  }, [_vm._v(" I can get a reward for every day "), _c('br'), _vm._v(" my friends participate ")]), _c('div', {
    staticClass: "popUsdInvite-friend__value"
  }, [_vm._v("1 Friend = "), _c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/TAP-small.png`),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$parent?.luckyInfo?.rewards?.invitation?.TAP))]), _c('div', {
    staticClass: "popUsdInvite-friend-btns"
  }, [_c('div', {
    staticClass: "btn btn-invite",
    on: {
      "click": _vm.onInvite
    }
  }, [!_vm.isInviteLoading ? [_vm._v("Invite Now")] : _c('div', {
    staticClass: "circleLoading"
  })], 2), _c('div', {
    directives: [{
      name: "copy",
      rawName: "v-copy",
      value: `https://t.me/${_vm.setting.botname}/app?startapp=ref_${_vm.userData.ref_code}-page_${_vm.$route.name == 'usdLucky' ? 'usdEvent' : _vm.$route.name}\n1,000,000 USDT for free!`,
      expression: "`https://t.me/${setting.botname}/app?startapp=ref_${userData.ref_code}-page_${$route.name == 'usdLucky' ? 'usdEvent' : $route.name}\\n1,000,000 USDT for free!`"
    }],
    staticClass: "btn btn-copy"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-copy"
    }
  })], 1)])]), _vm.activityList.length ? _c('div', {
    staticClass: "popUsdInvite-lists"
  }, [_c('div', {
    staticClass: "popUsdInvite-lists__title"
  }, [_vm._v("Activity")]), _c('div', {
    ref: "popUsdInviteRef",
    staticClass: "popUsdInvite-list"
  }, _vm._l(_vm.activityList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "popUsdInvite-item"
    }, [_c('div', {
      staticClass: "popUsdInvite-item__head"
    }, [_c('m-head', {
      attrs: {
        "name": item.from_user,
        "bgColor": item.from_user.head_color,
        "fontSize": "12",
        "size": "26"
      }
    })], 1), _c('div', {
      staticClass: "popUsdInvite-item-info"
    }, [_c('div', {
      staticClass: "popUsdInvite-item-info__name"
    }, [_vm._v(_vm._s(item.from_user.firstname) + " " + _vm._s(item.from_user.lastname))]), _c('div', {
      staticClass: "popUsdInvite-item-info__address"
    }, [_vm._v(_vm._s(_vm._f("formatTime")(item.created_at)))])]), _c('div', {
      staticClass: "popUsdInvite-item__price"
    }, [item.token == 'TAP' ? _c('img', {
      attrs: {
        "src": require(`@images/tapcoin/new/TAP-small.png`),
        "alt": ""
      }
    }) : item.token == 'TON' ? _c('img', {
      attrs: {
        "src": require(`@images/tapcoin/new/TON.png`),
        "alt": ""
      }
    }) : item.token == 'USDT' ? _c('img', {
      attrs: {
        "src": require(`@images/tapcoin/new/USDT-small.png`),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" + "), item.token == 'USDT' ? [_vm._v(_vm._s(_vm._f("fmt_usdtPre")(item.amount)))] : [_vm._v(_vm._s(_vm._f("fmt_pre")(item.amount)))]], 2)]);
  }), 0)]) : _vm._e(), _c('div', {
    staticClass: "popUsdInvite-btns",
    on: {
      "click": function ($event) {
        return _vm.$emit('skip');
      }
    }
  }, [_vm._v("Earn by completing tasks "), _c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/TAPSTOCK-small.png`),
      "alt": ""
    }
  })])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };